var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"camp-create__view"},[_c('Audience',{attrs:{"campaign":_vm.campaign},on:{"packsCountChanged":_vm.onPacksCountChanged}}),(_vm.packsLength)?[_c('div',{staticClass:"flex-end"},[_c('button',{staticClass:"btn btn--base btn--auto-w",attrs:{"id":"step1Next"},on:{"click":_vm.saveAndContinue}},[_vm._v(" Next ")])])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }